module.exports = __webpack_public_path__ + "img/36@2x.c4855e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/36@2x.png
// module id = j9Ap
// module chunks = 0